export default {
  clearObjectFields: (obj) => {
    Object.keys(obj).forEach(el => { obj[el] = null })
    return obj
  }

}
// Properly converts object to php suitable queryString
export const serialize = (obj, prefix) => {
  var str = []
    var p
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + '[' + p + ']' : p
        var v = obj[p]
      str.push((v !== null && typeof v === 'object')
      // eslint-disable-next-line
        ? serialize(v, k)
        : encodeURIComponent(k) + '=' + encodeURIComponent(v))
    }
  }
  return str.join('&')
}
